import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ProgramService } from '../program.service';

import { of } from "rxjs";


@Injectable()
export class ProgramsAvailableResolver implements Resolve<Observable<string>> {

    constructor(private programService: ProgramService) { }

    resolve() {
        return this.programService.getPrograms().catch(() => {
            return of('error');
        });
    }

}

